import type { ComponentType } from "react";
import type { ModuleDefinition, SlotProps } from "../../core/platform/registry/registry";
import { onSaleFinalized, onSaleVoided, onSaleRefunded } from "./subscriber";
import { loadReplica, forgetReplicaCache } from "./data/replica";
import { CartCard } from "./ui/CartCard";
import { AddCard } from "./ui/AddCard";
import { ShiftSummary } from "./ui/ShiftSummary";
import { LoyaltyButton } from "./ui/LoyaltyButton";

// Module-owned styles, imported here so core carries no stylesheet for a
// feature it does not know exists.
import "./ui/loyalty.css";

/**
 * The loyalty module, assembled (specs/006-loyalty).
 *
 * REACHES CORE ONLY THROUGH DECLARED EXTENSION POINTS: the sale events, a line
 * grant and a cart annotation from `till.cart.footer`, the recent-sale and
 * shift-close slots, and a header button. Core never calls it and learns
 * nothing about cards or stickers (Principle III).
 */
export function createLoyaltyModule(): ModuleDefinition {
  return {
    id: "loyalty",
    name: "Loyalty cards",
    version: "0.1.0",

    subscribers: {
      "sale.finalized": onSaleFinalized,
      "sale.voided": onSaleVoided,
      "sale.refunded": onSaleRefunded,
    },

    slots: {
      "till.cart.footer": CartCard as ComponentType<SlotProps>,
      "till.recentSale.actions": AddCard as ComponentType<SlotProps>,
      "till.shiftClose.summary": ShiftSummary as ComponentType<SlotProps>,
      "terminal.actions": LoyaltyButton as ComponentType<SlotProps>,
    },

    async onEnable() {
      await loadReplica();
    },

    onDisable() {
      forgetReplicaCache();
    },
  };
}

export default createLoyaltyModule;
